


  
  

  var faTiktokSquare = {
    prefix: 'fak',
    iconName: 'tiktok-square',
    icon: [
      448,
      512,
      [],
      'e000',
      
      'M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM261.4 98.6c6.9 0 13.9 0 20.8-.1c.6 21.3 9.2 40.5 23 54.7c14.8 13.3 34.1 22 55.3 23.5l.3 0 0 52.9c-20.1-.5-39-5.1-56-13.1l.9 .4c-8-3.8-14.8-7.8-21.3-12.2c0 14.2 0 28.4 0 42.6c0 24.1 0 48.1-.2 72.2c-1.1 19.5-7.5 37.2-17.9 52l.2-.3C249.1 396 221 412.3 189 413.3l-.1 0c-1.3 .1-2.8 .1-4.3 .1c-18.2 0-35.1-5.1-49.6-13.8l.4 .2c-26.3-15.8-44.5-43-47.9-74.5l0-.4c-.3-6.6-.4-13.1-.1-19.6c5.1-50.2 47.2-89 98.3-89c5.7 0 11.4 .5 16.8 1.4l-.6-.1c.2 11.1 0 22.2-.2 33.3c-.1 8.3-.3 16.6-.3 25c-4.4-1.6-9.6-2.5-14.9-2.5c-19.6 0-36.3 12.5-42.5 30l-.1 .3c-1.4 4.5-2.2 9.6-2.2 15c0 2.2 .1 4.3 .4 6.4l0-.3c3.5 21.5 21.9 37.7 44.1 37.7c.6 0 1.3 0 1.9 0l-.1 0c15.4-.5 28.7-8.7 36.2-20.9l.1-.2c2.8-3.9 4.7-8.6 5.4-13.8l0-.1c1-17.3 .9-34.6 .9-51.9c0-6.1 0-12.3 0-18.4c0-19.6 0-39.2 0-58.8c0-33.2 0-66.4 .2-99.5l0 0c10.2-.2 20.4-.2 30.5-.2z'
      
    ]
  };

  



export {

  faTiktokSquare,
  

};
